import axios from 'axios'
import API from '@/API.js'

const apiClient = axios.create({
  baseURL: `${API}/interfaz/vistas/campos`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: localStorage.getItem('argusblack.token')
  }
})

// Actualización del token de autorización
document.addEventListener('actualizar:token', function(e) {
  apiClient.defaults.headers['Authorization'] = e.detail
})

// Eliminación del token de autorización
document.addEventListener('eliminar:token', function() {
  apiClient.defaults.headers['Authorization'] = null
})

export default {
  actualizar(campo) {
    return apiClient.patch(`${campo.id}`, campo)
  },

  eliminar(idCampo) {
    return apiClient.delete(`${idCampo}`)
  },

  guardar(campo) {
    return apiClient.post('', campo)
  },

  vistaCampoJSON(idCampo) {
    return apiClient.get(`${idCampo}.json`)
  },

  vistasCamposJSON() {
    return apiClient.get(`${API}/interfaz/vistas/campos.json`)
  }
}